import React from 'react';
import { Card, CardContent } from './ui/card';
import { VEHICLES } from '../data/mockData';
import { Badge } from './ui/badge';

const Fleet = () => {
  return (
    <section id="filo" className="py-32 bg-[#0f0f10] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16 animate-accordion-down">
          <h2 className="text-4xl md:text-6xl font-bold mb-6">
            <span className="text-yellow-500">VIP</span> Filomuz
          </h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto">
            Sizler için özel olarak tasarlanmış, konfor ve güvenliğin en üst seviyede olduğu araçlarımızla hizmetinizdeyiz.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {VEHICLES.map((vehicle) => (
            <div key={vehicle.id} className="group relative">
                <div className="absolute -inset-0.5 bg-gradient-to-b from-yellow-500 to-transparent opacity-20 group-hover:opacity-100 transition duration-500 blur rounded-2xl"></div>
                <Card className="relative bg-[#1a1a1a] border-white/10 overflow-hidden h-full flex flex-col">
                    <div className="relative h-64 overflow-hidden">
                    <img 
                        src={vehicle.image} 
                        alt={vehicle.name} 
                        className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                    />
                    <div className="absolute top-4 right-4">
                        <Badge className="bg-yellow-500 text-black hover:bg-yellow-400 font-bold border-none px-3 py-1">
                            {vehicle.type}
                        </Badge>
                    </div>
                    </div>
                    <CardContent className="p-8 flex-1 flex flex-col">
                    <h3 className="text-2xl font-bold text-white mb-2 group-hover:text-yellow-500 transition-colors">{vehicle.name}</h3>
                    <p className="text-gray-400 mb-6 flex items-center gap-2 text-sm font-medium">
                        <span className="inline-block w-2 h-2 rounded-full bg-green-500 animate-pulse"></span>
                        {vehicle.capacity} Kapasite
                    </p>
                    <div className="space-y-3 mt-auto">
                        {vehicle.features.map((feature, idx) => (
                        <div key={idx} className="flex items-center text-sm text-gray-300">
                            <span className="text-yellow-500 mr-3">✓</span>
                            {feature}
                        </div>
                        ))}
                    </div>
                    <div className="mt-8 pt-6 border-t border-white/10">
                         <a href="https://wa.me/905468953037" target="_blank" rel="noopener noreferrer" className="block w-full">
                            <button className="w-full py-3 rounded-lg bg-white/5 hover:bg-yellow-500 hover:text-black text-white font-bold transition-all duration-300 border border-white/10 hover:border-transparent">
                                İncele & Kirala
                            </button>
                         </a>
                    </div>
                    </CardContent>
                </Card>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Fleet;
